export const newsApi = {
    heading:[
        
        {
            head:"News ID"
        },
        {
            head:"News Title"
        },
        {
            head:"News Date"
        },
        {
            head:"Description"
        },
        {
            head:"Active From"
        },
        {
            head:"Active To"
        },
        {
            head:"Action"
        }
    ],
    data:[
       {
        newsid:452,
        newstitle:"Vital News",
        newsdate:"06-06-2023",
        description:"This is a Breaking news",
        activeFrom:"20-06-2023",
        activeTo:"20-06-2023",
         action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
       },
    
      
     
   
       
    ]
}